import { getEntriesForRootKeys } from "./dictionary-db";
import { rootSpelling } from "./searchHistory";

// Autocomplete lists index keys, which drop hamza seats (قرا, سال). Maps each key to the
// spelling the dictionary itself uses for that root (قرأ, سأل) for display; the key is
// still what gets searched and stored.
export async function spellRootKeys(keys) {
  if (!keys || keys.length === 0) return new Map();
  const entries = await getEntriesForRootKeys(keys);
  return new Map(keys.map((key) => [key, rootSpelling(key, (entries.get(key) || []).map((e) => e.root))]));
}
